<template>
  <component :is="entity !== null ? 'div' : 'b-card'">
    <b-tabs
        v-if="entity"
        pills
    >

      <template v-if="entity!==null" v-for="tab in tabConfig.tabs ">

        <b-tab :active="tab.active">
          <template #title>
            <feather-icon
                icon="UserIcon"
                size="16"
                class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline"> {{ tab.title }} </span>
          </template>

          <template v-if="'Meta info' == tab.title">
            <form-fields :form-config="tab.config" :entity="entity['meta_info']"/>

          </template>
          <template v-else>
            <form-fields :form-config="tab.config" :entity="entity"/>
          </template>


        </b-tab>

      </template>

    </b-tabs>

    <b-button
        variant="primary" v-on:click="updateFunction"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Save Changes
    </b-button>
  </component>
</template>

<script>
import {BAlert, BCard, BLink, BTab, BTabs, BButton} from 'bootstrap-vue'
import {onUnmounted, ref} from '@vue/composition-api'
import store from '@/store'
import {FormConfig, PropertyConfig, FieldType, TabConfig} from '../common/index.d.ts'
import {useToast} from "vue-toastification/composition";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FormFields from './FormFields'
import {useRouter} from '@core/utils/utils'
import userStore from './storeModule'

export default {
  components: {
    BButton,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    FormFields,

  },


  props: {
    tabConfig: {
      type: TabConfig,
      required: true,
    },
    entityId: {
      type: [Number, String],
      required: true,
    },
  },

  setup(props) {
    const toast = useToast();
    const entity = ref(null);

    let r = {
      FieldType,
      entity,
      console,
    };
    let router = useRouter().router;
    // console.log(router);
    const tabConfig = props.tabConfig
    console.log(tabConfig)

    const USER_APP_STORE_MODULE_NAME = `app-edit-${tabConfig.entity}`
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {

      console.log(`registerModule ${USER_APP_STORE_MODULE_NAME}`)
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStore(tabConfig))

      onUnmounted(() => {
        if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
          console.log(`unregisterModule ${USER_APP_STORE_MODULE_NAME}`)

          store.unregisterModule(USER_APP_STORE_MODULE_NAME)
        }
      })
    } else {
      console.log(`already register ${USER_APP_STORE_MODULE_NAME}`)
    }
    const updateFunction = (e) => {

      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/update${tabConfig.entity}`, {
        id: props.entityId,
        body: entity.value
      })
          .then(response => {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: `${props.tabConfig.entity} Updated`,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            router.back();
          })
          .catch(error => {
            console.log(error);
          })
    };

    r.updateFunction = updateFunction;

    store.dispatch(`${USER_APP_STORE_MODULE_NAME}/get${tabConfig.entity}`, {id: props.entityId})
        .then(response => {
          let res = response.data.data
          console.log(res);
          for (const [key, value] of Object.entries(res)) {
            if (value instanceof Array && value !== undefined) {
              let arr = [];
              for (let i = 0; i < value.length; i++) {
                arr.push(value[i].id);
              }
              if (key.endsWith("ies")) {
                res[key.replaceAll("ies", "y_ids")] = arr;
              } else {
                res[key.substring(0, key.length - 1) + "_ids"] = arr;
              }
            } else if (value instanceof Object && value !== undefined) {
              console.log(key);
              res[key + "_id"] = value.id;
            }
          }
          if (res.hasOwnProperty("meta_info") && res["meta_info"] == null) {
            res["meta_info"] = {}
          }
          entity.value = res;
        })
        .catch(error => {
          if (error.response.status === 404) {
            entity.value = undefined
          }
        })
    return r;
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/tree.scss";
</style>
